export const getLocationSlugFromUrl = (title: string): string => {
  return window?.location?.href.split('/')[3] || title
}
